/** Момент старта акции в полном ISO-формате: срок считается с точностью до минуты. */
export const AVIA_TOUR_PROMO_START_DATE = '2026-09-01T00:00:00+05:00';
export const AVIA_TOUR_PROMO_DURATION_DAYS = 14;
export const AVIA_TOUR_PROMO_DISCOUNT_AMOUNT = 40_000;
export const AVIA_TOUR_PROMO_CODE = 'AVIA7X4K';
